module.exports = __webpack_public_path__ + "img/101.c255c96a.svg";